module.exports = __webpack_public_path__ + "img/TD.e99b6682.svg";